import { useState } from "react";
import FormContactServices from "../../services";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const FormContact = () =>{ 
    const[formData, setFormData] = useState({
        name:'',
        phone:'',
        email:'',
        message:'',
        
    }) 
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState({
      allFieldRequierd: '',
      serverEmailError: '',
    });

      /** On toast success */
  const showToastSuccessMsg = (msg) => {
    toast.success(msg, {
      position: 'bottom-center',
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  };

    /** On toast error */
    const showToastErrorMsg = (msg) => {
        toast.error(msg, {
          position: 'bottom-center',
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      };
  

    const handleInputChange = (e) => {
        const inputData = {...formData, [e.target.name]: e.target.value };
        setFormData(inputData)
    }

    const resetFormData = () =>{
        setFormData({
            name:'',
            phone:'',
            email:'',
            message:'',
        })
    }

    const onFormSubmit = async (e) =>{
        e.preventDefault();
        if ([
              formData?.name,
              formData?.email,
              formData?.phone,
              formData?.message,
            ].includes('')
          ) {
            showToastErrorMsg('Todos los campos son obligatorios');
            return;
          }
        
    try {
        /** FormSubmit Service */
        setLoading(true);
        const response = await FormContactServices.postForm(
          formData?.name,
          formData?.email,
          formData?.phone,
          formData?.message,
          'fabians@bidata.cl'
        //   realtorData?.email
        );
  
  
        if (response?.success === 'false') {
          setErrorMsg({
            allFieldRequierd: '',
            serverEmailError:
              'Se necesita activación de email del administrador/a',
          });
          setLoading(false);
          resetFormData();
          return;
        }
  
        if (response?.success === 'true') {
          setLoading(false);
          setErrorMsg({
            allFieldRequierd: '',
            serverEmailError: '',
          });
          showToastSuccessMsg(
            `Solicitud enviada exitosamente, dentro de poco de contactaremos`
          );
          setTimeout(() => {
            resetFormData();
            window.location.reload();
          }, 3000);
        }
      } catch (error) {
        showToastErrorMsg('Ha ocurrido un error al enviar el formulario');
      }
    }

    
    return(
        <>
        <div className="my-5 mb-10 flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                <form name="FormSubmit" onSubmit={onFormSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Nombre</label>
                        <input 
                          type="text" placeholder="Nombre" name="name" id="name"
                          className="border-2 border-gray-300 p-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-primary-default focus:border-transparent" 
                          value={formData?.name}
                          onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Telefono</label>
                        <input 
                          type="tel" placeholder="972525722" name="phone" id="phone"
                          className="border-2 border-gray-300 p-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-primary-default focus:border-transparent"  
                          value={formData?.phone} 
                          onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Correo</label>
                        <input 
                          type="email" placeholder="correo@correo.com" name="email" id="email"
                          className="border-2 border-gray-300 p-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-primary-default focus:border-transparent" 
                          value={formData?.email} 
                          onChange={handleInputChange} 
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700">Mensaje</label>
                        <textarea 
                          type="text" placeholder="Escribenos más detalles" name="message" id="message"
                          className="border-2 border-gray-300 p-2 rounded-lg w-full h-32 resize-none focus:outline-none focus:ring-2 focus:ring-primary-default focus:border-transparent" 
                          value={formData?.message} 
                          onChange={handleInputChange}
                        ></textarea>
                    </div>
                    {errorMsg?.serverEmailError && (
                      <alert type="danger" message={errorMsg?.serverEmailError} />
                    )}
                    <button 
                      type="submit" 
                      className="bg-primary-default text-white p-2 rounded-lg font-semibold w-full hover:bg-primary-opacity focus:outline-none focus:ring-2 focus:ring-primary-default focus:ring-offset-2 focus:ring-offset-gray-100"
                    >
                      {loading ? (
                        <div role="status">
                          <svg
                            aria-hidden="true"
                            className={`inline w-4 h-4 `}
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                          <span className="sr-only">Cargando...</span>
                        </div>
                        ) : (
                          <span>Enviar</span>
                        )}
                    </button>
                </form>
            </div>
            <ToastContainer />
        </div>
        </>
    )

}

export default FormContact;